// extracted by mini-css-extract-plugin
export default {"body":"CloseLabTestDialog_body__V3jdx","intro":"CloseLabTestDialog_intro__iKc10","label":"CloseLabTestDialog_label__gijmn","actions":"CloseLabTestDialog_actions__TE-0e"};